import { Field } from './Field'
import { RecordDataMap } from './RecordDataMap'

export const isCustomizable = (obj: any): boolean => {
    return obj?.iCustomizable === true
}

export interface Customizable {
    iCustomizable: true
    id?: string
    fields(): Promise<Field[]>
    fieldValues: RecordDataMap
}
